<div class="main-container">
  <div class="grid-container" id="tr-report-grid-container">
    <div class="top-toolbar">
      <div class="float-left ml-2">
        @if (taxyearLoaded) {
          <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'"
            [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem"
            (onSelect)="onTaxYearChanged($event)">
            @for (item of taxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)"
                (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }
 
        <button class="export-btn" (click)="exportToExcel()">
          <i class="Appkit4-icon icon-save-outline"></i>
          Export to Excel
        </button>
      </div>
    </div>
 
    <div class="dst-mat-grid-layout transfers-review-grid">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div #matGridContainer class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
          (matSortChange)="onMatSortChange()" class="dst-mat-table transfers-review-table">
 
          <ng-container matColumnDef="TAXYEAR" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="stmt-frozen-col trr-year-col"
              [ngStyle]="getColStyle(frozenCols[0])" [dstMatColumnResize]="getColWidthPx(frozenCols[0])"
              (widthChange)="onColumnWidthChange(frozenCols[0], $event)">
              {{ frozenCols[0].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" class="stmt-frozen-col trr-year-col"
              [ngStyle]="getColStyle(frozenCols[0])" [attr.id]="rowData.STATEMENTID">
              <span>{{ rowData.TAXYEAR }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="STATEMENTID" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              class="stmt-frozen-col trr-stmt-id-col trr-frozen-end-col" [ngStyle]="getColStyle(frozenCols[1])"
              [dstMatColumnResize]="getColWidthPx(frozenCols[1])"
              (widthChange)="onColumnWidthChange(frozenCols[1], $event)">
              {{ frozenCols[1].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" class="stmt-frozen-col trr-stmt-id-col trr-frozen-end-col"
              [ngStyle]="getColStyle(frozenCols[1])">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="STATEMENTNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])"
              [dstMatColumnResize]="getColWidthPx(cols[0])" (widthChange)="onColumnWidthChange(cols[0], $event)">
              {{ cols[0].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
              <span>{{ rowData.STATEMENTNAME }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="PRIMARYBUSINESS">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])"
              [dstMatColumnResize]="getColWidthPx(cols[1])" (widthChange)="onColumnWidthChange(cols[1], $event)">
              {{ cols[1].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
              <span>{{ rowData.PRIMARYBUSINESS }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="PRIMARYLEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])"
              [dstMatColumnResize]="getColWidthPx(cols[2])" (widthChange)="onColumnWidthChange(cols[2], $event)">
              {{ cols[2].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
              <span>{{ rowData.PRIMARYLEID }}</span><br />
              <span style="font-style: italic">{{ rowData.SECONDARYLEID }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="PRIMARYENTITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])"
              [dstMatColumnResize]="getColWidthPx(cols[3])" (widthChange)="onColumnWidthChange(cols[3], $event)">
              {{ cols[3].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[3])">
              <span>{{ rowData.PRIMARYENTITY }}</span><br />
              <span style="font-style: italic">{{ rowData.SECONDARYENTITY }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="TRANS_TYPE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])"
              [dstMatColumnResize]="getColWidthPx(cols[4])" (widthChange)="onColumnWidthChange(cols[4], $event)">
              {{ cols[4].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[4])">
              <span>{{ rowData.TRANS_TYPE }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="LIQUIDATIONDATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])"
              [dstMatColumnResize]="getColWidthPx(cols[5])" (widthChange)="onColumnWidthChange(cols[5], $event)">
              {{ cols[5].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
              <span>{{ rowData.LIQUIDATIONDATE }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="CURRENCYNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])"
              [dstMatColumnResize]="getColWidthPx(cols[6])" (widthChange)="onColumnWidthChange(cols[6], $event)">
              {{ cols[6].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
              <span>{{ rowData.CURRENCYNAME }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="BASISDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])"
              [dstMatColumnResize]="getColWidthPx(cols[7])" (widthChange)="onColumnWidthChange(cols[7], $event)">
              {{ cols[7].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[7])">
              <span>{{ rowData.BASISDESC }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="BASISNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])"
              [dstMatColumnResize]="getColWidthPx(cols[8])" (widthChange)="onColumnWidthChange(cols[8], $event)">
              {{ cols[8].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
              <span>{{ rowData.BASISNAME }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="BASISAMT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])"
              [dstMatColumnResize]="getColWidthPx(cols[9])" (widthChange)="onColumnWidthChange(cols[9], $event)">
              {{ cols[9].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[9])">
              <span>{{ rowData.BASISAMT | number }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="LIABILITIES">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])"
              [dstMatColumnResize]="getColWidthPx(cols[10])" (widthChange)="onColumnWidthChange(cols[10], $event)">
              {{ cols[10].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
              <span>{{ rowData.LIABILITIES | number }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="NETAMOUNT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])"
              [dstMatColumnResize]="getColWidthPx(cols[11])" (widthChange)="onColumnWidthChange(cols[11], $event)">
              {{ cols[11].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[11])">
              <span>{{ rowData.NETAMOUNT | number }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="FMVAMT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])"
              [dstMatColumnResize]="getColWidthPx(cols[12])" (widthChange)="onColumnWidthChange(cols[12], $event)">
              {{ cols[12].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[12])">
              <span>{{ rowData.FMVAMT | number }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="BASISFMVALERT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])"
              [dstMatColumnResize]="getColWidthPx(cols[13])" (widthChange)="onColumnWidthChange(cols[13], $event)">
              {{ cols[13].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[13])" style="text-align: center;">
              <span>{{ rowData.BASISFMVALERT }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="IMPORTATIONPROPERTYDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])"
              [dstMatColumnResize]="getColWidthPx(cols[14])" (widthChange)="onColumnWidthChange(cols[14], $event)">
              {{ cols[14].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
              <span>{{ rowData.IMPORTATIONPROPERTYDESC }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="LOSSDUPLICATIONPROPERTYDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])"
              [dstMatColumnResize]="getColWidthPx(cols[15])" (widthChange)="onColumnWidthChange(cols[15], $event)">
              {{ cols[15].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[15])">
              <span>{{ rowData.LOSSDUPLICATIONPROPERTYDESC }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="GAINLOSSPROPERTYDESC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])"
              [dstMatColumnResize]="getColWidthPx(cols[16])" (widthChange)="onColumnWidthChange(cols[16], $event)">
              {{ cols[16].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[16])">
              <span>{{ rowData.GAINLOSSPROPERTYDESC }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="POTENTIAL_BIL_IMPORTATION">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])"
              [dstMatColumnResize]="getColWidthPx(cols[17])" (widthChange)="onColumnWidthChange(cols[17], $event)">
              {{ cols[17].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[17])" style="text-align: center;">
              <span>{{ rowData.POTENTIAL_BIL_IMPORTATION }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="POTENTIAL_362_E_ALERT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])"
              [dstMatColumnResize]="getColWidthPx(cols[18])" (widthChange)="onColumnWidthChange(cols[18], $event)">
              {{ cols[18].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[18])" style="text-align: center;">
              <span>{{ rowData.POTENTIAL_362_E_ALERT }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="IS_362_LIMIT_MADE">
            <th mat-header-cell *matHeaderCellDef class="trr-long-header" [ngStyle]="getColStyle(cols[19])"
              [dstMatColumnResize]="getColWidthPx(cols[19])" (widthChange)="onColumnWidthChange(cols[19], $event)">
              {{ cols[19].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[19])">
              <div class="row">
                <div class="col-md-10 pr-0 rev-Expl">
                  <ap-dropdown class="field-full-width" [list]="rowData['revExplanations']" [selectType]="'single'"
                    [showSearchbox]="true" [title]="'Select'" [hideTitleOnInput]="true" [inputAriaLabel]="'Select'"
                    [(ngModel)]="rowData.selectedExplanationItem"
                    [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled"
                    (onSelect)="reviewerExplanationChange($event, rowData)">
                    @for (item of rowData['revExplanations']; track $index) {
                      <ap-dropdown-list-item #dropdownListItem [item]="item"
                        [ariaLabel]="setAriaLabel(item, 'Reviewer Explanation')"
                        (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                    }
                  </ap-dropdown>
                </div>
                @if (rowData.TRANSFER_REIVEW_NAME === 'Yes (provide Stmt ID in the textbox)') {
                  <div class="col-md-2">
                    <span class="Appkit4-icon icon-pencil-outline pt-2" (click)="yesExplanation(rowData)"></span>
                  </div>
                }
              </div>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="REVIEW_EXPL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])"
              [dstMatColumnResize]="getColWidthPx(cols[20])" (widthChange)="onColumnWidthChange(cols[20], $event)">
              {{ cols[20].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[20])">
              <span>{{ rowData.TRANSFER_REVIEW_EXPLANATION }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="ISREVIEWED">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])"
              [dstMatColumnResize]="getColWidthPx(cols[21])" (widthChange)="onColumnWidthChange(cols[21], $event)">
              {{ cols[21].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" class="item-aligned" [ngStyle]="getColStyle(cols[21])">
              <ap-checkbox [styleClass]="'a-mx-10'" [ngModel]="rowData.ISREVIEWED === 'Reviewed'"
                (onChange)="statementReviewedChange($event, rowData)"
                [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled">
              </ap-checkbox>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="ISQAR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])"
              [dstMatColumnResize]="getColWidthPx(cols[22])" (widthChange)="onColumnWidthChange(cols[22], $event)">
              {{ cols[22].header }}
              <span class="dst-mat-col-resize-handle"></span>
            </th>
            <td mat-cell *matCellDef="let rowData" class="item-aligned" [ngStyle]="getColStyle(cols[22])">
              <span>{{ rowData.ISQAR }}</span>
            </td>
          </ng-container>
 
          <ng-container matColumnDef="TAXYEAR_filter" sticky>
            <th mat-header-cell *matHeaderCellDef class="stmt-frozen-col trr-year-col"
              [ngStyle]="getColStyle(frozenCols[0])"></th>
          </ng-container>
 
          <ng-container matColumnDef="STATEMENTID_filter" sticky>
            <th mat-header-cell *matHeaderCellDef class="stmt-frozen-col trr-stmt-id-col trr-frozen-end-col"
              [ngStyle]="getColStyle(frozenCols[1])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fStatementId"
                (input)="filterCol($event, 'STATEMENTID', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="STATEMENTNAME_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[0])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fStatementName"
                (input)="filterCol($event, 'STATEMENTNAME', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="PRIMARYBUSINESS_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[1])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fBusiness"
                (input)="filterCol($event, 'PRIMARYBUSINESS', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="PRIMARYLEID_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[2])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fLeid"
                (input)="filterCol($event, 'PRIMARYLEID', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="PRIMARYENTITY_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[3])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fEntityName"
                (input)="filterCol($event, 'PRIMARYENTITY', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="TRANS_TYPE_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[4])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fTransactionType"
                (input)="filterCol($event, 'TRANS_TYPE', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="LIQUIDATIONDATE_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[5])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fDateofTransfer"
                (input)="filterCol($event, 'LIQUIDATIONDATE', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="CURRENCYNAME_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[6])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fCurrency"
                (input)="filterCol($event, 'CURRENCYNAME', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="BASISDESC_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[7])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fDescPropTransfered"
                (input)="filterCol($event, 'BASISDESC', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="BASISNAME_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[8])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fBasisPropTransferred"
                (input)="filterCol($event, 'BASISNAME', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="BASISAMT_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[9])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fBasisAmount"
                (input)="filterCol($event, 'BASISAMT', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="LIABILITIES_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[10])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fLiabilitiesAssumed"
                (input)="filterCol($event, 'LIABILITIES', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="NETAMOUNT_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[11])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fNetAmount"
                (input)="filterCol($event, 'NETAMOUNT', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="FMVAMT_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[12])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fFmvAmount"
                (input)="filterCol($event, 'FMVAMT', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="BASISFMVALERT_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[13])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fFmvBasisAlert"
                (input)="filterCol($event, 'BASISFMVALERT', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="IMPORTATIONPROPERTYDESC_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[14])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fImpPropDesc"
                (input)="filterCol($event, 'IMPORTATIONPROPERTYDESC', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="LOSSDUPLICATIONPROPERTYDESC_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[15])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fLossDupliPropDesc"
                (input)="filterCol($event, 'LOSSDUPLICATIONPROPERTYDESC', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="GAINLOSSPROPERTYDESC_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[16])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fRecogGlPropDesc"
                (input)="filterCol($event, 'GAINLOSSPROPERTYDESC', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="POTENTIAL_BIL_IMPORTATION_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[17])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fPotentialBilLossImport"
                (input)="filterCol($event, 'POTENTIAL_BIL_IMPORTATION', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="POTENTIAL_362_E_ALERT_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[18])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fPotential362EAlert"
                (input)="filterCol($event, 'POTENTIAL_362_E_ALERT', 'contains')">
            </th>
          </ng-container>
 
          <ng-container matColumnDef="IS_362_LIMIT_MADE_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[19])"></th>
          </ng-container>
 
          <ng-container matColumnDef="REVIEW_EXPL_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[20])"></th>
          </ng-container>
 
          <ng-container matColumnDef="ISREVIEWED_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[21])"></th>
          </ng-container>
 
          <ng-container matColumnDef="ISQAR_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(cols[22])">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fIsQar"
                (input)="filterCol($event, 'ISQAR', 'contains')">
            </th>
          </ng-container>
 
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="trr-header-row"></tr>
          <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="dst-mat-filter-row"
            style="height: 45px;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="trr-data-row"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell dst-mat-no-records" [attr.colspan]="displayedColumns.length">
              <span>No Records Found.</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
 
  @if (showModalViewer) {
    <dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
    </dst-disc-modal-viewer>
  }
</div>
 
@if (showYesExplanationModal) {
  <ap-modal #yesExplanationModal [appModalId]="'rev-yes-exp'"
    [ariaLabel]="yesExplActiveRow.STATEMENTID + ' - Yes:'" [title]="yesExplActiveRow.STATEMENTID + ' - Yes:'"
    [closable]="true" [style]="{'width': '31.25rem'}" (onClose)="onYesExplanationCancel('rev-yes-exp')">
    <div class="tr-report-modal-body">
      <p>Please Enter Statement Id to Match.</p>
      <ap-field [styleClass]="'yes-expl-height'" [title]="''"
        [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled">
        <textarea appkit-field [(ngModel)]="yesExplanationText" aria-label="Yes explanation"></textarea>
      </ap-field>
    </div>
    <ng-template ngTemplate="footer">
      <ap-button [compact]="true" [btnType]="'primary'" [label]="'Save'" class="ap-mr-spacing-3"
        (onClick)="onYesExplanationSave('rev-yes-exp')"
        [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled"></ap-button>
      <ap-button [compact]="true" [btnType]="'secondary'" [label]="'Cancel'"
        (onClick)="onYesExplanationCancel('rev-yes-exp')"></ap-button>
    </ng-template>
  </ap-modal>
}
 